import { AfterViewInit, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tiktok-success',
  imports: [CommonModule],
  templateUrl: './tiktok-success.component.html',
  styleUrl: './tiktok-success.component.css'
})
export class TiktokSuccessComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
